<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.assetmanufacturer_model"
        :filters.sync="filters"
        @apply="reload"
        @ready="initial"
      />

      <el-card shadow="never">
        <Models
          ref="modelTable"
          v-loading="loading"
          :models="models"
        >
          <template
            v-if="canUpdate || canDelete"
            v-slot:action="props"
          >
            <el-button
              v-if="canUpdate"
              size="mini"
              @click.native="showEditForm(props.models)"
            >
              Edit
            </el-button>
            <el-button
              v-if="canDelete"
              size="mini"
              type="danger"
              @click.native="deleteModel(props.models)"
            >
              Delete
            </el-button>
          </template>
        </Models>
        <el-pagination
          class="text-center"
          :current-page.sync="models.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="models.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="models.total"
          @size-change="reload"
          @current-change="reload"
        />
        <CreateEditForm
          v-if="isShowEditForm"
          ref="actionForm"
          :model="model"
          :is-show.sync="isShowEditForm"
          @reload="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Models from '@/components/Application/Configuration/Assets/Manufacturer/Model/Table'
import CreateEditForm from '@/components/Application/Configuration/Assets/Manufacturer/Model/CreateEditForm'
import Filters from '@/components/Filters/Complex'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'

export default {
  components: {
    Models,
    CreateEditForm,
    Filters
  },
  data () {
    return {
      title: 'Models',
      breadcrumb:
      {
        name: 'Models',
        route: { name: 'configuration-assets-models' }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'assetmanufacturer_model'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.model = new this.$sdk.assetmanufacturer_model()
            this.isShowEditForm = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.reload()
        }
      ],
      filters: [],
      models: [],
      loading: true,
      isShowEditForm: false,
      model: null
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'assetmanufacturer_model')
    },
    canDelete () {
      return this.$user.can(DELETE, 'assetmanufacturer_model')
    }
  },
  methods: {
    initial () {
      this.loading = true

      if (this.$route.params.manufacturerId && this.$route.params.manufacturerId !== 'models') {
        this.$sdk.assetmanufacturer_model.list(builder => {
          builder.context = { resource: 'assetmanufacturer', id: this.$route.params.manufacturerId }
          builder.include = 'type,asset_manufacturer'
          builder.filters = this.filters
        }).then(res => {
          this.models = res
        })
          .finally(() => { this.loading = false })
      } else {
        this.$sdk.assetmanufacturer_model.list(builder => {
          builder.include = 'type,asset_manufacturer'
          builder.filters = this.filters
        }).then(res => {
          this.models = res
        })
          .finally(() => { this.loading = false })
      }
    },
    async reload () {
      this.loading = true

      try {
        await this.models.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('Failed to load Asset Manufacturers models')
      }

      this.loading = false
    },
    showEditForm (row) {
      this.model = row.clone()
      this.isShowEditForm = true
    },
    deleteModel (model) {
      this.$confirm('Are you sure to delete this asset\'s manufacturer model ?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        model.delete()
          .then(res => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.reload())
      }).catch(() => {})
    }
  }
}
</script>
